import BlackLoaderIcon from '../../../../static/icons/loader_black.svg';
import WhiteLoaderIcon from '../../../../static/icons/loader_white.svg';

export const LoadingColors = Object.freeze({
  BLACK: BlackLoaderIcon,
  WHITE: WhiteLoaderIcon,
});
